import { connect } from 'react-redux';
import GiftCardChargeButton from '../components/GiftCardChargeButton';
import { closePayment, openGiftCardPayment } from '../reducer/currentPayment/actions';
import { getIsFetching } from '../reducer/isFetching/selectors';
import { getHasGiftCardPayment } from '../reducer/payments/selectors';
import { getHasPaymentOpened, getIsGiftCardOpened } from '../reducer/currentPayment/selectors';

const GiftCardChargeButtonContainer = connect(
  state => ({
    opened: getIsGiftCardOpened(state),
    disabled: getIsFetching(state) || getHasPaymentOpened(state) || getHasGiftCardPayment(state),
  }),
  { close: closePayment, open: openGiftCardPayment }
)(GiftCardChargeButton);

export default GiftCardChargeButtonContainer;
